import React, { useState, useEffect } from 'react';
import { mountOn } from './lib/mount';
import { showToast } from './lib/toast';
import { API } from './lib/api';
import { MyDocumentsSection, CommunitySection } from './components/community';

function LibraryRoot() {
  const el = document.getElementById('library-root');
  const loggedIn = el?.dataset.loggedIn === 'true';
  const [documents, setDocuments] = useState(null);
  const [maxDocuments, setMaxDocuments] = useState(5);
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    if (!loggedIn) return;
    fetch(API.documentsOwned, { headers: { 'Accept': 'application/json' } })
      .then(async r => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then(data => { setDocuments(data.documents); setMaxDocuments(data.max_documents); })
      .catch(err => {
        console.error('Failed to load documents:', err);
        showToast('Failed to load documents', { type: 'error' });
      });
  }, [loggedIn]);

  const handleNewDoc = async () => {
    if (creating) return;
    setCreating(true);
    try {
      const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
      const res = await fetch(API.createDocument, {
        method: 'POST',
        headers: { 'Accept': 'application/json', ...(csrf && { 'X-CSRF-Token': csrf }) },
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.errors?.[0] || 'Failed to create document');
      window.track && window.track('document_created');
      window.location.href = data.edit_path;
    } catch (e) {
      showToast(e.message, { type: 'error' });
      setCreating(false);
    }
  };

  return (
    <div className="library-view">
      {loggedIn && (
        <div className="lib-hero">
          <h1 className="lib-hero-title ty-heading-xl">Build it. Export it. Fly with it.</h1>
        </div>
      )}
      {loggedIn && (
        <MyDocumentsSection
          library={documents}
          maxDocuments={maxDocuments}
          loading={documents === null}
          creating={creating}
          onNewDoc={handleNewDoc}
          onToast={showToast}
        />
      )}
      {!loggedIn && (
        <div className="lib-hero">
          <h1 className="lib-hero-title ty-heading-xl">Build it. Export it. Fly with it. Explore documents made by our community.</h1>
        </div>
      )}
      <CommunitySection isLoggedIn={loggedIn} onToast={showToast} />
    </div>
  );
}

mountOn('library-root', <LibraryRoot />);
